import { ThunkDispatch } from 'redux-thunk';
import { IReduxRootState } from '../../app/reduxRootState.interface';
import { deleteAccountCancelMember } from '../privacyCenter/privacyCenter.services';
import { ErrorResolutionActions } from '../../app/common/errorResolution/errorResolutionActions';
import {
    ErrorResolution,
    ErrorResolutionTypes,
} from '../../app/common/errorResolution/errorResolution';
import { NOTIFICATIONS } from '../../app/common/constants/styles';
import ErrorRedirectService from '../../routes/error/errorRedirect.service';
import { NotificationType } from '../../app/common/notifications/notificationType.enum';
import { TextHelpers } from '../../utils/textHelpers';
import { getChallengeData } from '../../utils/challengerMain';
import { IMemberInfo } from './cancelMemberState';
import { CancelMembershipAction, CancelMembershipActionType } from './cancelmembershipActionType';
import { ICancelMembershipRequest } from './cancelmembershipRequest';
import { addRatEvent } from '../../utils/ratClickEvents';

export class CancelMembershipActions {
    public static cancelMembership(user: IMemberInfo, challengerPid: string) {
        return (
            dispatch: ThunkDispatch<IReduxRootState, {}, CancelMembershipAction>,
            getState: () => IReduxRootState,
        ) => {
            const app = getState().app;

            const challengeData = getChallengeData(challengerPid);

            const data: ICancelMembershipRequest = {
                challengeData: challengeData,
                clientId: app.clientConfig.clientId,
            };

            dispatch(CancelMembershipActions.request(user));

            return deleteAccountCancelMember(data, '')
                .then((_) => {
                    const locale = app.locale;
                    const { cancelMemberStaticUrl } = app.clientConfig;

                    const url = cancelMemberStaticUrl.success as string;
                    const cancelMemberSuccessUrl = TextHelpers.replaceLang(url, locale);

                    addRatEvent('member_cancellation', 'cancel_member_success');

                    dispatch(
                        ErrorResolutionActions.processErrorResolution({
                            errorMessageId: 'notifications.account.deleted',
                            type: ErrorResolutionTypes.ERROR_CODE_MESSAGE,
                        }),
                    );

                    setInterval(() => {
                        dispatch(CancelMembershipActions.success());
                        ErrorRedirectService.takeToLogout(cancelMemberSuccessUrl);
                    }, NOTIFICATIONS[NotificationType.Error].expiry);
                })
                .catch((error) => {
                    addRatEvent('member_cancellation', 'cancel_member_fail');

                    dispatch(CancelMembershipActions.failure(error));
                    dispatch(
                        ErrorResolutionActions.processErrorResolution(
                            error,
                            'notifications.cancelMembership.deleteAccountCancelMember.failure',
                            { challengerPid: data.challengeData.cpid },
                        ),
                    );
                });
        };
    }

    public static startDeleteAccount(): CancelMembershipAction {
        addRatEvent('member_cancellation', 'start_cancel_member');
        return {
            type: CancelMembershipActionType.CANCEL_MEMBERSHIP_START,
        };
    }

    private static request(member: IMemberInfo): CancelMembershipAction {
        return {
            payload: { member },
            type: CancelMembershipActionType.CANCEL_MEMBERSHIP_REQUEST,
        };
    }

    private static success(): CancelMembershipAction {
        return {
            type: CancelMembershipActionType.CANCEL_MEMBERSHIP_SUCCESS,
            payload: {},
        };
    }

    private static failure(error: ErrorResolution): CancelMembershipAction {
        return {
            payload: { errorResolution: error },
            type: CancelMembershipActionType.CANCEL_MEMBERSHIP_FAILURE,
        };
    }

    public static closeCancelMembershipOverlay(): CancelMembershipAction {
        addRatEvent('member_cancellation', 'quit_cancel_member');
        return {
            payload: {},
            type: CancelMembershipActionType.CLOSE_CANCEL_MEMBERSHIP_OVERLAY,
        };
    }

    public static openCancelMembershipOverlay(): CancelMembershipAction {
        return {
            payload: {},
            type: CancelMembershipActionType.OPEN_CANCEL_MEMBERSHIP_OVERLAY,
        };
    }

    public static cancelMemberGoBack(): CancelMembershipAction {
        addRatEvent('member_cancellation', 'keep_member');
        return {
            type: CancelMembershipActionType.CLOSE_CANCEL_MEMBERSHIP_PAGE,
        };
    }
}
